import { animate, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { COMPLEX_ACCELERATING, COMPLEX_DECELERATING } from '@mtna/core-angular';
import { PackagingFormat, PackagingOptions } from '@rds/rds-packaging-ts';

/**
 * A list of packaging formats grouped by type.
 * Each list item can be clicked in order to build up a list of desired formats.
 *
 * @author Will Davis <will.davis@mtna.us>
 */
@Component({
  selector: 'rds-c-format-selection-list',
  templateUrl: './format-selection-list.component.html',
  styleUrls: ['./format-selection-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('slideInOut', [
      state('in', style({ opacity: 1, transform: 'translateX(0)' })),
      transition(':enter', [style({ opacity: 0, transform: 'translateX(-100%)' }), animate(COMPLEX_DECELERATING)]),
      transition(':leave', [animate(COMPLEX_ACCELERATING, style({ opacity: 0, transform: 'translateX(-100%)' }))]),
    ]),
  ],
})
export class RdsFormatSelectionListComponent {
  /** Options to display in the list */
  @Input() options: PackagingOptions | undefined;
  /** Selected packaging formats */
  @Input() selected: Array<PackagingFormat> | undefined;
  /** Emitted when a format is added */
  @Output() add = new EventEmitter<PackagingFormat>();
  /** Emitted when a format is removed */
  @Output() remove = new EventEmitter<PackagingFormat>();
}
